(function () {
  window.DiscountYardErrorMessageTimeout = 1000 * 60 * 60 * 24; // 1 day

  function cleanErrorMessageOnInput() {
    const TIMEOUT = 5000;
    const start = Date.now();

    const interval = setInterval(() => {
      const couponInput = document.querySelector('#coupons_stacker_input');
      if (couponInput) {
        document.querySelectorAll('#coupons_stacker_input').forEach((el) => 
          el.setAttribute('aria-label',
              el.closest('#coupons_stacker_wrapper').querySelector('label[for="coupons_stacker_input"]').innerText
          )
        );
        couponInput.addEventListener('input', window.StackDiscounts.toggleErrorMessages.bind(null, false));
        clearInterval(interval);
      }
      if (Date.now() - start > TIMEOUT) {
        clearInterval(interval);
      }
    }, 200);

  }

  try {
    window.addEventListener('load', () => {
      cleanErrorMessageOnInput();
    });
  } catch (err) {
      console.error(err);
  }
})();
